<template>
    <div>
        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('bookings.headline.license_information') }}
            </div>

            <div class="form-row">
                <div
                    class="form-row__col form-row__col--one-half"
                    v-if="isAdmin"
                >
                    <label class="label" for="send_notification">
                        {{ trans('bookings.label.send_notification') }}
                    </label>
                    <select
                        name="send_notification"
                        class="form-select"
                        v-model="fields.sendNotification"
                        id="send_notification"
                    >
                        <option disabled>{{
                            trans('clients.label.select')
                        }}</option>
                        <option value="1">{{ trans('form.yes') }}</option>
                        <option value="0">{{ trans('form.no') }}</option>
                    </select>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-date
                        name="start_date"
                        :initial-date="new Date(Date.now())"
                        v-model="fields.startDate"
                        :min-date="minDate"
                        :required="true"
                    >
                        {{ trans('bookings.label.start_date') }}
                    </form-date>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="license_amount"
                        :required="true"
                        type="number"
                        min="1"
                        step="1"
                        v-model="fields.licenseAmount"
                    >
                        {{ trans('bookings.label.license_amount') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row" v-if="fields.sendNotification == '0'">
                <div class="form-row__col">
                    <form-text-area
                        name="reason"
                        :required="true"
                        v-model="fields.reason"
                    >
                        {{ trans('bookings.label.reason') }}
                    </form-text-area>
                </div>
            </div>
        </section>

        <section class="form-section" v-if="fields.sendNotification == '1'">
            <div class="form-section-heading">
                {{ trans('bookings.headline.interval_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label" for="repeat">
                        {{ trans('bookings.label.repeat') }}
                    </label>
                    <select
                        name="repeat"
                        class="form-select"
                        v-model="fields.repeat"
                        id="repeat"
                    >
                        <option disabled>{{ trans('form.select') }}</option>
                        <option value="1">{{ trans('form.yes') }}</option>
                        <option value="0">{{ trans('form.no') }}</option>
                    </select>
                </div>

                <div
                    class="form-row__col form-row__col--one-half"
                    v-if="fields.repeat == '1'"
                >
                    <form-input
                        name="repeat_period"
                        :required="true"
                        type="number"
                        min="1"
                        step="1"
                        v-model="fields.repeatPeriod"
                    >
                        {{ trans('bookings.label.repeat_period') }}
                    </form-input>
                </div>
            </div>
        </section>

        <div class="page-control">
            <div
                class="page-control__element"
                v-if="!fields.sendNotification || isAdmin || parentUser"
            >
                <button type="submit" class="btn btn--big btn--primary">
                    {{ trans('licenses.label.add_licenses') }}
                </button>
            </div>
            <div
                class="page-control__element"
                v-if="fields.sendNotification && !isAdmin && !parentUser"
            >
                <button type="submit" class="btn btn--big btn--primary">
                    {{ trans('licenses.label.buy_bindingly') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        booking: {
            type: Object,
            default: () => {
                return {};
            },
        },
        isAdmin: {
            type: Boolean,
        },
        parentUser: {
            type: Boolean,
        },
    },

    data() {
        return {
            fields: {
                licenseAmount: this.old('license_amount'),
                startDate: this.old('start_date'),
                repeat: this.old('repeat', 0),
                repeatPeriod: this.old('repeat_period', 12),
                sendNotification: this.old('send_notification', 1),
                reason: this.old('reason'),
            },
            minDate: new Date(),
        };
    },
};
</script>
